import { MenuItem, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Column } from "../../Layout/utils";
import { useGetStatusList } from "../../Pricing/utils";
import { StatusOptions } from "../../services/Alert";
import { PriceUpdateStatus } from "../../services/Price";
import { formInputsStyles } from "../../Configuration/styles";

export const CreateFilterStatusForm = ({
  data,
  onSubmit,
}: {
  data: StatusOptions;
  onSubmit: (data: StatusOptions) => void;
}) => {
  const intl = useIntl();
  const inputStyles = formInputsStyles();
  const [selectedMode, setSelectedMode] = useState<PriceUpdateStatus>(
    data.value
  );
  const statuses = useGetStatusList();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const mode = event.target.value as PriceUpdateStatus;
    setSelectedMode(mode);
  };

  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const params: any = { value: selectedMode };
    onSubmit(params);
  };

  useEffect(() => {
    setSelectedMode(data.value);
  }, [data]);

  return (
    <form
      id="create-filter-form"
      autoComplete="off"
      onSubmit={handleSubmit}
      className={inputStyles.classes.root}
    >
      <Column
        className={`${inputStyles.classes.container} ${inputStyles.classes.inputSize}`}
        sx={{
          gap: 1,
        }}
      >
        <TextField
          className={inputStyles.classes.select}
          variant="outlined"
          id="standard-select-date"
          fullWidth
          label={intl.formatMessage({ id: "SELECT_STATUS_MODE" })}
          onChange={handleChange}
          select
          value={selectedMode}
        >
          {statuses.map((option) => (
            <MenuItem key={option.name} value={option.name}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Column>
    </form>
  );
};
